import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/DynamicFieldsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const deleteDynamicField = async (uuid: string) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteDynamicField(uuid),
    { headers: { Accept: 'application/vnd.falcon.v1+json' } },
  );
  return data;
};

export const useDeleteDynamicField = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteDynamicField,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.dynamicFieldDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.DYNAMIC_FIELDS] });
    },
    onError: handleError,
  });
};
